@if (lastDetail) {
  <div [ngClass]="'bg-text-' + severity()">
    <div>{{ 'person.dashboard.riskStatus.fields.riskType' | translate }}: {{ lastStatus()?.riskType }}</div>
    <div>
      {{ 'person.dashboard.riskStatus.fields.status' | translate }}:
      {{ (lastStatus()?.status ? 'enum.folderRiskStatus.' + lastStatus().status : '') | translate }}
    </div>
    <div>{{ 'person.dashboard.riskStatus.riskFrom' | translate }}: {{ lastStatus()?.dateFrom | date: 'd. M. y' }}
    </div>
    <div>{{ 'person.dashboard.riskStatus.fields.note' | translate }}: {{ lastStatus()?.note }}</div>
  </div>
} @else {
  <app-table
    [items]="store.items()"
    [columns]="columns"
    translatePrefix="person.dashboard.riskStatus."
    [hideCheckboxes]="true"
    (detailCallback)="detail($event)"
    (deleteCallbackWithEvent)="delete($event)"
    >
    <ng-template pTemplate="status" let-data="data">
      {{ 'enum.folderRiskStatus.' + data | translate }}
    </ng-template>
  </app-table>
}

